import { Collection } from './collection';
import { BBModel } from '../bb_model';

class EventChainCollection extends Collection {

    constructor(resource, set) {
        super(resource, set);
        this.promise = resource.$get('event_chains')
            .then((eventChains) => {
                this.url = resource.$link('self').href;
                this.items = eventChains.map(eventChain => new BBModel.Admin.EventChain(eventChain));
                this.items.forEach(eventChain => set.updateItem(eventChain));
                this.total_entries = resource.total_entries;
                this.listenForPush(set);
                return this;
            });
    }

    static $query(set, company, params = {}) {
        return super.$query(EventChainCollection, set, company, params);
    }

}

EventChainCollection.group = 'event_chains';

export {
    EventChainCollection
};
